<template>
    <div class="page-container">
        <div class="page-header content-fade-in">
            <div class="title">会议列表</div>
            <div class="subtitle">查看和管理历史会议记录</div>
        </div>
        
        <div class="content-container">
            <div class="list-wrapper" ref="containerRef">
                <div class="search-controls">
                    <div class="search-box" ref="searchRef">
                        <a-input class="search-input" v-model:value="searchState.meeting_no" placeholder="请输入会议号" allowClear />
                        <a-input class="search-input" v-model:value="searchState.title" placeholder="请输入会议名称" allowClear />
                        <a-button class="search-btn button-shimmer" type="primary" @click="refreshTable">搜索</a-button>
                    </div>
                    
                    <div class="info-summary">
                        <div class="summary-item">
                            <div class="summary-count">{{ pagination.total || 0 }}</div>
                            <div class="summary-label">总会议数</div>
                        </div>
                    </div>
                </div>
                
                <a-table ref="tableRef" :columns="columns" :row-key="record => record.id" :data-source="dataSource"
                    :pagination="pagination" :loading="loading" @change="handleTableChange" :scroll="{ y: tableHeight, x: '100%' }"
                    class="meeting-table content-slide-up" style="animation-delay: 0.1s;">
                    <template #bodyCell="{ column, text, record }">
                        <template v-if="column.dataIndex === 'name'">{{ text }}</template>
                        <template v-else-if="column.dataIndex === 'audio_file_status' || column.dataIndex === 'audio_record_status' || column.dataIndex === 'audio_summit_status'">
                            <a-tag :color="getStatusColor(text)">{{ text }}</a-tag>
                        </template>
                        <template v-else-if="column.key === 'action'">
                            <div class="action-buttons">
                                <a-button type="link" size="small" @click="edit(record.key)">详情</a-button>
                                <a-button type="link" size="small" @click="downloadAll(record)">下载</a-button>
                                <a-button type="link" danger size="small" @click="showDeleteConfirm(record)">删除</a-button>
                            </div>
                        </template>
                    </template>
                </a-table>
            </div>
            
            <div class="meeting-tips">
                <div class="tips-title">会议管理指南</div>
                <ul class="tips-list">
                    <li>您可以通过会议号或名称快速搜索历史会议</li>
                    <li>点击"详情"可查看会议完整内容和转写文本</li>
                    <li>下载功能支持多种格式的会议记录导出</li>
                    <li>删除操作需要管理员验证码确认，请谨慎操作</li>
                </ul>
                
                <div class="status-legend">
                    <div class="legend-title">状态图例</div>
                    <div class="legend-items">
                        <div class="legend-item">
                            <a-tag color="success">已生成</a-tag>
                            <span>处理完成，可查看下载</span>
                        </div>
                        <div class="legend-item">
                            <a-tag color="warning">生成中</a-tag>
                            <span>正在处理，请稍候</span>
                        </div>
                        <div class="legend-item">
                            <a-tag color="default">未生成</a-tag>
                            <span>尚未开始处理</span>
                        </div>
                    </div>
                </div>
            </div>

            <a-modal v-model:open="downloadVisible" title="下载会议内容" width="540px" :footer="null" class="download-modal">
                <div class="download-title">{{ meetingOneData.name }}</div>
                <div class="download-content">
                    <div class="download-content-head">
                        <span>
                            <a-checkbox :checked="downloadCheckAll" :indeterminate="downloadIndeterminate"
                                @change="checkAllChange"></a-checkbox>
                        </span>
                        <span>文件内容</span>
                        <span>文件格式</span>
                    </div>
                    <div>
                        <span>
                            <a-checkbox v-model:checked="downloadAudioFile.checked"></a-checkbox>
                        </span>
                        <span>录音文件</span>
                        <span>
                            <a-select v-model:value="downloadAudioFile.type" class="w-120px">
                                <a-select-option value="MP3">MP3</a-select-option>
                                <a-select-option value="WAV">WAV</a-select-option>
                            </a-select>
                        </span>
                    </div>
                    <div>
                        <span>
                            <a-checkbox v-model:checked="downloadAudioOriginRecord.checked"></a-checkbox>
                        </span>
                        <span>原始记录</span>
                        <span>
                            <a-select v-model:value="downloadAudioOriginRecord.type" class="w-120px">
                                <a-select-option value="WORD">WORD</a-select-option>
                                <a-select-option value="PDF">PDF</a-select-option>
                            </a-select>
                        </span>
                    </div>
                    <div>
                        <span>
                            <a-checkbox v-model:checked="downloadAudioRecord.checked"></a-checkbox>
                        </span>
                        <span>语义顺滑</span>
                        <span>
                            <a-select v-model:value="downloadAudioRecord.type" class="w-120px">
                                <a-select-option value="WORD">WORD</a-select-option>
                                <a-select-option value="PDF">PDF</a-select-option>
                            </a-select>
                        </span>
                    </div>
                    <div>
                        <span>
                            <a-checkbox v-model:checked="downloadAudioSummit.checked"></a-checkbox>
                        </span>
                        <span>会议纪要</span>
                        <span>
                            <a-select v-model:value="downloadAudioSummit.type" class="w-120px">
                                <a-select-option value="WORD">WORD</a-select-option>
                                <a-select-option value="PDF">PDF</a-select-option>
                            </a-select>
                        </span>
                    </div>
                </div>
                <div class="download-content-foot">
                    <a-button type="primary" size="large" class="download-button button-shimmer" @click="downloadword">下载</a-button>
                </div>
            </a-modal>

            <a-modal v-model:open="deleteModalVisible" title="删除确认" @ok="handleDelete" @cancel="cancelDelete" class="delete-modal">
                <div class="delete-prompt">
                    <div class="delete-warning">
                        <warning-outlined class="warning-icon" />
                        <div>会议记录删除后将无法恢复，请谨慎操作！</div>
                    </div>
                    <p>请输入管理员提供的验证码以确认删除</p>
                    <a-input v-model:value="userInputCode" placeholder="请输入验证码" />
                </div>
            </a-modal>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { BASE_URL } from '@/config/api';
import { useRouter } from 'vue-router';
import { WarningOutlined } from '@ant-design/icons-vue';

const dataSource = ref([]);
const loading = ref(false);
const pagination = ref({ 
    current: 1, 
    pageSize: 10,
    total: 0,
    size: "default",
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条记录`
});

const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})

const router = useRouter()
const state = {
    data: [
    ]
}

const columns = [
    {
        title: '会议号',
        dataIndex: 'meeting_no',
        with: '6%',
    },
    {
        title: '会议名称',
        dataIndex: 'title',
        sorter: false,
        width: '20%',
    },
    {
        title: '会议时间',
        dataIndex: 'create_time',
        sorter: true,
        width: '12%',
    },
    {
        title: '参会人员',
        dataIndex: 'speaker',
        sorter: false,
        width: '12%'
    },
    {
        title: '录音文件',
        dataIndex: 'audio_file_status',
        sorter: false,
        width: '10%'
    },
    {
        title: '会议记录',
        dataIndex: 'audio_record_status',
        sorter: false,
        width: '10%'
    },
    {
        title: '会议纪要',
        dataIndex: 'audio_summit_status',
        sorter: false,
        width: '10%'
    },
    {
        title: '操作',
        key: 'action',
        width: '15%',
        fixed: 'right'
    },
];

// 获取状态标签颜色
const getStatusColor = (status) => {
    if (status === '已生成') return 'success';
    if (status === '生成中') return 'warning';
    return 'default';
};

let meetingOneData = {
    meeting_id: 0,
    name: '',
    users: [],
    meettime: '',
}

const downloadword = async () => {
    console.log('downloadAudioFile', downloadAudioFile)
    if( false == downloadAudioFile.value.checked &&  false == downloadAudioOriginRecord.value.checked && false == downloadAudioRecord.value.checked && false == downloadAudioSummit.value.checked){
        message.error('需要至少选择一项!');
        return
    }

    loading.value = true;
    try {
        const response = await axios.post(`${BASE_URL}/downloadword/${meetingOneData.meeting_id}`, {
            audio_file: downloadAudioFile.value.checked,
            audio_record: downloadAudioRecord.value.checked,
            audio_summit: downloadAudioSummit.value.checked,
            audio_file_type: downloadAudioFile.value.type,
            audio_origin_record: downloadAudioOriginRecord.value.checked,
            audio_origin_record_type: downloadAudioOriginRecord.value.type,
            audio_record_type: downloadAudioRecord.value.type,
            audio_summit_type: downloadAudioSummit.value.type
        });

        // 响应就是一个zip文档 直接下载
        let file_path = response.data.file_path
        // 自动触发下载file_path链接的zip文件
        const a = document.createElement('a');
        a.href = file_path;
        a.download = meetingOneData.name + '.zip';
        a.click();
        message.success('下载已开始');
        downloadVisible.value = false;
        return true;
    } catch (error) {
        console.error('Download failed:', error);
        message.error('下载失败：不适当的文件或格式');
        return false;
    } finally {
        loading.value = false;
    }
};

const fetchData = async (page, pageSize, sortField, sortOrder, filters, searchKeyword,meeting_no) => {
    loading.value = true;
    try {
        const response = await axios.get(`${BASE_URL}/meeting`, {
            params: {
                page,
                size: pageSize,
                sortField,
                sortOrder,
                ...filters,
                title: searchKeyword,
                meeting_no,
                active_id: myPermission.value.id
            },
        });
        const data = response.data;
        if (Array.isArray(data.items)) {
            console.log('data.items', data.items)
            dataSource.value = data.items.map(item => ({
                key: item.id,
                title: item.title,
                meeting_no: item.meeting_no,
                create_time: item.create_time,
                speaker: item.speaker,
                audio_file_status: item.audio_file_status === 0 ? '未生成' : item.audio_file_status === 1 ? '生成中' : '已生成',
                audio_record_status: item.audio_record_status === 0 ? '未生成' : item.audio_record_status === 1 ? '生成中' : '已生成',
                audio_summit_status: item.audio_summit_status === 0 ? '未生成' : item.audio_summit_status === 1 ? '生成中' : '已生成'
            }));
            pagination.value.total = data.total;
            pagination.value.current = data.page;
        } else {
            console.error('API response is not an array:', data);
        }
    } catch (error) {
        console.error('Failed to fetch data:', error);
        message.error('获取数据失败，请重试');
    } finally {
        loading.value = false;
    }
};


const handleTableChange = (pag, filters, sorter) => {
    fetchData(pag.current, pag.pageSize, sorter.field, sorter.order, filters, searchState.title, searchState.meeting_no);
};

const refreshTable = () => {
    pagination.value.current = 1
    fetchData(pagination.value.current, pagination.value.pageSize, null, null, {}, searchState.title, searchState.meeting_no);
}

// 初始数据加载
fetchData(pagination.value.current, pagination.value.pageSize);

const edit = (key) => {
    console.log('edit', key);
    router.push({ path: '/meetingedit/' + key })
};

// 获取某个会议的信息
const get_one_meeting = async (meeting_id) => {
    loading.value = true;
    let id = meeting_id
    meetingOneData.meeting_id = id
    console.log('meeting_id', meeting_id)
    try {
        const response = await fetch(`${BASE_URL}/meeting/${id}`);
        const data = await response.json();
        console.log('data', data)
        // data.speaker = 1,2 变成数组
        let userlist = data.speaker.includes(',') ? data.speaker.split(',') : [data.speaker];

        if (data.speaker == "") {
            userlist = []
            meetingOneData.users = []
        } else {
            // 遍历 userlist 并结合 state.data的数据 获得 label和value数组
            const selectedUsers = userlist.map(userName => {
                const user = state.data.find(item => item.label === userName);
                console.log('user', user)
                return {
                    label: user?.label || userName,
                    value: user?.value || 0
                };
            });
            meetingOneData.users = selectedUsers;
        }

        meetingOneData.name = data.title
        meetingOneData.meettime = '立刻开始'
    } catch (error) {
        console.error('Failed to fetch meeting data:', error);
        message.error('获取会议数据失败');
    } finally {
        loading.value = false;
    }
};


const downloadVisible = ref(false)
const downloadCheckAll = computed(() => {
    return downloadAudioFile.value.checked
        && downloadAudioRecord.value.checked
        && downloadAudioOriginRecord.value.checked
        && downloadAudioSummit.value.checked
})
const downloadIndeterminate = computed(() => {
    return !downloadCheckAll.value && (downloadAudioFile.value.checked
        || downloadAudioRecord.value.checked
        || downloadAudioOriginRecord.value.checked
        || downloadAudioSummit.value.checked)
})
const checkAllChange = (event) => {
    const isChecked = event.target.checked
    downloadAudioFile.value.checked = isChecked
    downloadAudioRecord.value.checked = isChecked
    downloadAudioOriginRecord.value.checked = isChecked
    downloadAudioSummit.value.checked = isChecked
}
// 录音文件
const downloadAudioFile = ref({
    type: 'MP3',
    checked: false
})
// 语义顺滑
const downloadAudioRecord = ref({
    type: 'WORD',
    checked: false
})
// 原始记录
const downloadAudioOriginRecord = ref({
    type: 'WORD',
    checked: false
})
// 会议纪要
const downloadAudioSummit = ref({
    type: 'WORD',
    checked: false
})
const downloadAll = (record) => {
    console.log(record)
    get_one_meeting(record.key)
    downloadVisible.value = true
}

const searchRef = ref()
const tableRef = ref()
const containerRef = ref()
// 表格最大高度
const tableHeight = ref(500);

// 防抖函数，用于优化 ResizeObserver 回调执行频率
const debounce = (fn, delay) => {
  let timer = null;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};

// 优化计算表格高度的函数，添加错误处理并使用防抖
const calculateTableHeight = debounce(() => {
  try {
    if (!containerRef.value || !searchRef.value || !tableRef.value) return;
    
    const containerHeight = containerRef.value.clientHeight;
    if (!containerHeight) return;
    
    const searchHeight = searchRef.value.clientHeight || 0;
    const tHead = tableRef.value.$el.querySelector('.ant-table-header');
    const tFoot = tableRef.value.$el.querySelector('.ant-table-pagination');
    const tHeadHeight = tHead?.clientHeight ?? 0;
    const tFootHeight = tFoot?.clientHeight ?? 0 + 32;
    
    // 设置最小高度，防止计算出过小的值
    const calculatedHeight = Math.max(
      400, 
      containerHeight - searchHeight - tHeadHeight - tFootHeight - 24 * 2
    );
    
    tableHeight.value = calculatedHeight;
    console.log('Table height calculated:', calculatedHeight);
  } catch (error) {
    console.error('计算表格高度出错:', error);
    // 设置一个合理的默认高度
    tableHeight.value = 500;
  }
}, 200);

let resizeObserver = null;

onMounted(() => {
  fetchData(pagination.value.current, pagination.value.pageSize);
  
  // 延迟执行 DOM 相关操作，确保组件已完全渲染
  nextTick(() => {
    containerRef.value = document.querySelector('.list-wrapper');
    
    if (containerRef.value) {
      calculateTableHeight();
      
      // 创建 ResizeObserver 实例
      try {
        resizeObserver = new ResizeObserver(calculateTableHeight);
        resizeObserver.observe(containerRef.value);
      } catch (error) {
        console.error('ResizeObserver 初始化失败:', error);
      }
      
      // 添加窗口大小变化监听器作为备选方案
      window.addEventListener('resize', calculateTableHeight);
    }
  });
});

onBeforeUnmount(() => {
  // 清理 ResizeObserver
  if (resizeObserver) {
    try {
      if (containerRef.value) {
        resizeObserver.unobserve(containerRef.value);
      }
      resizeObserver.disconnect();
      resizeObserver = null;
    } catch (error) {
      console.error('清理 ResizeObserver 失败:', error);
    }
  }
  
  // 清理窗口事件监听器
  window.removeEventListener('resize', calculateTableHeight);
});

const deleteModalVisible = ref(false);
const userInputCode = ref('');
const currentRecord = ref(null);

const showDeleteConfirm = (record) => {
    currentRecord.value = record;
    userInputCode.value = '';
    deleteModalVisible.value = true;
};

const handleDelete = async () => {    
    if (!userInputCode.value.trim()) {
        message.error('请输入验证码');
        return;
    }
    
    loading.value = true;
    try {
        await axios.delete(`${BASE_URL}/meeting/${currentRecord.value.key}`, {
            data: {
                agent_id: myPermission.value.id,
                verification_code: userInputCode.value
            }
        });
        message.success('删除成功');
        deleteModalVisible.value = false;
        refreshTable();
    } catch (error) {
        console.error('Failed to delete:', error);
        if (error.response?.data?.message) {
            message.error(error.response.data.message);
        } else {
            message.error('删除失败');
        }
    } finally {
        loading.value = false;
    }
};

const cancelDelete = () => {
    deleteModalVisible.value = false;
    userInputCode.value = '';
    currentRecord.value = null;
};

const searchState = reactive({
    title: '',
    meeting_no: ''
});

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.page-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;  /* 防止整个页面滚动 */
}

.content-container {
    display: grid;
    grid-template-columns: 1fr 280px;
    grid-gap: 24px;
    padding: 0;
    box-shadow: none;
    background: transparent;
    height: 100%;  /* 将高度设为100%撑满父容器 */
    flex: 1;
    overflow: hidden;  /* 防止content-container滚动 */
}

.list-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0 24px;
    grid-column: 1 / 3;
}

.list-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #3949AB, #5C6BC0);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    box-shadow: 0 4px 12px rgba(57, 73, 171, 0.25);
}

.list-icon-inner {
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' /%3E%3C/svg%3E");
    background-size: contain;
}

.list-desc {
    font-size: 16px;
    font-weight: 500;
    color: #1E293B;
}

.list-wrapper {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: var(--card-shadow);
    padding: 24px;
    grid-column: 1 / 2;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;  /* 确保wrapper占满高度 */
}

.meeting-tips {
    background-color: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: var(--card-shadow);
    grid-column: 2 / 3;
    align-self: start;
}

.tips-title {
    font-size: 16px;
    font-weight: 600;
    color: #0F172A;
    margin-bottom: 16px;
    border-bottom: 1px solid #E2E8F0;
    padding-bottom: 12px;
}

.tips-list {
    padding-left: 20px;
    margin: 0 0 24px 0;
    
    li {
        margin-bottom: 12px;
        color: #64748B;
        line-height: 1.5;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
}

.status-legend {
    background-color: #F8FAFC;
    border-radius: 8px;
    padding: 16px;
    margin-top: 20px;
}

.legend-title {
    font-weight: 600;
    color: #334155;
    margin-bottom: 12px;
    font-size: 14px;
}

.legend-items {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.legend-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    
    .ant-tag {
        margin-right: 8px;
    }
    
    span {
        color: #64748B;
    }
}

.search-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.search-box {
    display: flex;
    align-items: center;
}

.search-input {
    width: 200px;
    margin-right: 8px;
}

.search-btn {
    margin-left: 8px;
}

.info-summary {
    display: flex;
    align-items: center;
}

.summary-item {
    text-align: center;
    padding: 0 16px;
    
    .summary-count {
        font-size: 18px;
        font-weight: 600;
        color: #3949AB;
    }
    
    .summary-label {
        font-size: 12px;
        color: #64748B;
    }
}

.meeting-table {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    
    .action-buttons {
        display: flex;
        gap: 8px;
    }
    
    :deep(.ant-table) {
        flex: 1;
        overflow: hidden;
    }
    
    :deep(.ant-table-wrapper) {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    
    :deep(.ant-spin-nested-loading) {
        flex: 1;
        height: 100%;
    }
    
    :deep(.ant-spin-container) {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    
    :deep(.ant-table-container) {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
    
    :deep(.ant-table-body) {
        overflow-y: auto !important;
    }
    
    :deep(.ant-table-tbody > tr > td) {
        vertical-align: middle;
    }
    
    :deep(.ant-tag) {
        margin-right: 0;
        min-width: 64px;
        text-align: center;
    }
    
    :deep(.ant-pagination-options) {
        .ant-select-dropdown {
            z-index: 9999 !important;
        }
    }
    
    :deep(.ant-select-dropdown) {
        z-index: 9999 !important;
    }
}

.download-modal {
    .download-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        color: #1E293B;
    }

    .download-content {
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 10px;
        margin-bottom: 15px;
        
        > div {
            display: flex;
            align-items: center;
            padding: 12px 10px;
            border-bottom: 1px solid #F1F5F9;
            
            &:last-child {
                border-bottom: none;
            }
        }
        
        .download-content-head {
            font-weight: 600;
            background-color: #F8FAFC;
            padding: 12px 10px;
            color: #334155;
        }
        
        span:nth-child(1) {
            flex: 0 0 50px;
            text-align: center;
        }
        
        span:nth-child(2) {
            flex: 1;
            padding-left: 10px;
            color: #334155;
        }
        
        span:nth-child(3) {
            flex: 0 0 150px;
            text-align: center;
        }
    }

    .download-content-foot {
        display: flex;
        justify-content: center;
        margin-top: 24px;
    }

    .download-button {
        min-width: 160px;
        height: 40px !important;
    }
}

.delete-modal {
    .delete-prompt {
        .delete-warning {
            display: flex;
            align-items: center;
            background-color: #FEF2F2;
            border: 1px solid #FECACA;
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 20px;
            
            .warning-icon {
                color: #EF4444;
                font-size: 18px;
                margin-right: 12px;
            }
            
            div {
                color: #B91C1C;
                font-weight: 500;
            }
        }
        
        p {
            margin-bottom: 12px;
            color: #334155;
        }
    }
}

.w-120px {
    width: 120px !important;
}
</style>
